const state = {
  orderList: [],
}
const mutations = {
  setOrderList (state, orderList) {
    state.orderList = orderList
  },
}
const actions = {

}
const modules = {
}

export default {
  state,
  mutations,
  actions,
  modules,
  namespaced: true
}